export const SET_OTHER_CREDENTIALS = 'SET_OTHER_CREDENTIALS';
